import { IStyles } from '../models/app/IStyles';

const mobileMax = '558px';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				documentDownloadListWrapper: {
					display: 'flex',
					flex: {
						direction: 'row',
						wrap: 'wrap',
					},
					justifyContent: 'space-between',
					overrides: [
						{
							selector: '.multi-document-list[data-selector="file-documentDownloadList-wrapper"]',
							style: {
								flex: {
									basis: '49%',
								},
								width: '100%',
								breakpoints: [
									{
										media: ['screen'],
										max: mobileMax,
										style: {
											flex: {
												grow: '1',
												basis: '100%',
											},
										},
									},
								],
							},
						},
						{
							selector: '[data-selector="file-documentDownloadList-wrapper"]:last-of-type [data-selector="base-list-heading"]',
							style: {
								breakpoints: [
									{
										media: ['screen'],
										max: mobileMax,
										style: {
											margin: {
												top: '60px',
											},
										},
									},
								],
							},
						},
					],
				},
				wrapper: {

				},
			},
		},
	},
	theme: {
		base: {
			application: {
				font: {
					family: 'Heebo, Arial',
					size: '16px',
				},
				color: '#001928',
			},
			grid: {
				children: {
					row: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
					},
					column: {
						display: 'flex',
						flex: {
							_value: '1',
							direction: 'column',
						},
						margin: {
							right: '20px',
						},
					},
				},
			},
			list: {
				children: {
					heading: {
						height: '24px',
						color: '#001928',
						font: {
							size: '16px',
							weight: 'bold',
						},
						lineHeight: '24px',
						margin: {
							bottom: '8px',
						},
					},
					placeholder: {
						font: {
							style: 'italic',
						},
					},
					multipartListItem: {
						display: 'flex',
						height: '55px',
						border: {
							bottom: {
								_value: '1px solid #C7C7C7',
							},
						},
					},
					listItem: {
						border: {
							bottom: {
								_value: '1px solid #999',
							},
						},
					},
					content: {
						flex: {
							_value: 'auto',
						},
					},
					firstContent: {
						flex: {
							_value: 'auto',
						},
					},
					lastContent: {
						flex: {
							grow: '0',
						},
					},
					listItemWrapper: {
						listStyle: {
							type: 'none',
						},
					},
					unorderedList: {
						listStyle: {
							type: 'none',
						},
						margin: {
							block: {
								start: '0px',
								end: '0px',
							},
							inline: {
								start: '0px',
								end: '0px',
							},
						},
						padding: {
							inline: {
								start: '0px',
								end: '0px',
							},
						},
					},
				},
			},
			image: {
				children: {
					styledImage: {
						verticalAlign: 'middle',
					},
				},
			},
			checkbox: {
				children: {
					icon: {
						verticalAlign: 'middle',
					},
				},
			},
			contextMenu: {
				children: {
					// wrapper: {
					// 	position: 'relative',
					// },
					button: {
						border: {
							style: 'none',
						},
						outline: {
							style: 'none',
						},
						font: {
							size: '16px',
							family: 'Heebo, Arial',
							weight: 'normal',
						},
						lineHeight: '18px',
						color: '#001928',
						padding: {
							_value: '0',
						},
						margin: {
							_value: '0',
						},
					},
					icon: {
						verticalAlign: 'middle',
						margin: {
							left: '11px',
						},
						breakpoints: [
							{
								media: ['screen'],
								max: mobileMax,
								style: {
									margin: {
										left: '0px',
									},
								},
							},
						],
					},
					dropdown: {
						margin: {
							top: '2px',
						},
						border: {
							color: '#cccccc',
							style: 'solid',
							width: 'thin',
							radius: '3px',
						},
						right: '0',
						position: 'absolute',
						min: {
							width: '100px',
						},
						background: {
							color: 'white',
						},
						box: {
							shadow: '3px 3px 5px 0px rgba(199,199,199,1)',
						},
						zIndex: '20',
					},
					dropdownItem: {
						display: 'block',
						font: {
							size: '14px',
							weight: '500',
						},
						color: '#4A4A4A',
						padding: {
							left: '8px',
							right: '8px',
						},
						height: '39px',
						lineHeight: '16px',
						selectors: [
							{
								':hover': {
									background: {
										color: '#D9DCE1',
									},
									cursor: 'pointer',
								},
							},
							{
								':not': {
									_parameters: [':last-child'],
									border: {
										bottom: {
											_value: '1px solid #C7C7C7',
										},
									},
								},
							},
						],
						verticalAlign: 'middle',
					},
					clickLayer: {
						position: 'fixed',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
						zIndex: '10',
					},
				},
			},
			heading: {
				position: 'relative',
				width: '100%',
			},
			pill: {
				text: {
					transform: 'uppercase',
				},
				conditionals: [
					{
						conditional: {
							conditions: [
								{
									field: 'priority',
									operator: '=',
									value: 'primary',
								},
							],
						},
						style: {
							font: {
								size: '12px',
							},
							border: {
								radius: '17px',
							},
							background: {
								color: '#0075BE',
							},
							color: '#ffffff',
							padding: {
								_value: '2px 8px',
							},
						},
					},
				],
			},
			card: {
				children: {
					header: {
						overrides: [
							{
								selector: '[data-selector="base-card-title"]',
								style: {
									font: {
										size: '32px',
										weight: '300',
									},
									margin: {
										bottom: '28px',
									},
								},
							},
						],
					},
				},
			},
		},
		file: {
			documentDownload: {
				children: {
					wrapper: {
						padding: {
							top: '20px',
							bottom: '18px',
							left: '18px',
						},
					},
					documentItemWrapper: {
						padding: {
							top: '10px',
						},
					},
					documentLabel: {
						lineHeight: '18px',
						padding: {
							right: '4px',
						},
						whiteSpace: 'nowrap',
						overrides: [
							{
								selector: '[data-selector="base-icon"]',
								style: {
									margin: {
										left: '11px',
									},
									height: '19px',
									width: '18px',
									selectors: [
										{
											':hover': {
												cursor: 'pointer',
											},
										},
									],
								},
							},
						],
					},
					icon: {
						verticalAlign: 'middle',
					},
					contextMenuItemIcon: {
						float: 'right',
						overrides: [
							{
								selector: '[data-selector="base-icon"]',
								style: {
									height: '19px',
									width: '18px',
									margin: {
										left: '11px',
									},
								},
							},
						],
					},
					label: {
						selectors: [
							{
								':hover': {
									cursor: 'pointer',
								},
							},
						],
					},
				},
			},
			documentDownloadList: {
				children: {
					wrapper: {
						position: 'relative',
					},
					documentLabel: {
						lineHeight: '18px',
						whiteSpace: 'nowrap',
						padding: {
							top: '20px',
							bottom: '18px',
							left: '8px',
						},
					},
				},
				overrides: [
					{
						selector: '[data-selector="base-list"]',
						style: {
							padding: {
								left: '0',
							},
							margin: {
								top: '0',
							},
							border: {
								top: {
									_value: '1px solid #C7C7C7',
								},
							},
						},
					},
					{
						selector: '[data-selector="base-list-heading"]',
						style: {
							text: {
								transform: 'uppercase',
							},
							margin: {
								top: '0px',
							},
						},
					},
				],
			},
			bulkDocumentDownload: {
				children: {
					wrapper: {
						margin: {
							top: '39px',
						},
					},
					linkButton: {
						border: {
							style: 'solid',
							width: '2px;',
							radius: '24.5px',
							color: '#0075BF',
						},
						padding: {
							_value: '13px 23px',
						},
						font: {
							size: '13px',
							weight: 'bold',
						},
						color: '#0075BF',
						text: {
							transform: 'uppercase',
						},
					},
				},
			},
		},
		overview: {
			disclaimers: {
				children: {
					wrapper: {
						margin: {
							top: '30px',
						},
					},
				},

			},
		},
	},
};